export const capitalizeFirstNameRole = (role) => {
    if (!role) return '';

    // Split the role by spaces and capitalize the first letter of each word
    const capitalizedRole = role?.charAt(0).toUpperCase() + role.slice(1).toLowerCase();

    return capitalizedRole;
}